module.exports = __webpack_public_path__ + "static/media/logo.c3e1aa19.svg";